export function assignWork(works, job) {
    let { assignWorkRequest, assignWorkError, assignWorkResult } = this.props

    this.doAction(
        this.WEB_REQUEST_URL + 'assign_work',
        this.createBundle('assign_work', { works, job }, this.POST, assignWorkRequest, assignWorkResult, assignWorkError)
    )
}
